import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import AppIcon from '../../assets/icons/app-icon.svg?react';
import ROUTES from '../../routes/routeConstants';
import { HeaderNav } from './HeaderNav';
import { UserMenu } from './UserMenu';
import { LocationSelector } from '../LocationSelector/LocationSelector';
import styles from './Header.module.css';

export const Header = () => {
  const { t } = useTranslation();

  return (
    <header className={styles.header}>
      <Link to={ROUTES.root} className={styles.homeLink}>
        <AppIcon className={styles.appIcon} />
        <span className={styles.title}>{t('app-title')}</span>
      </Link>
      <HeaderNav />
      <div className={styles.rightActions}>
        <LocationSelector />
        <UserMenu />
      </div>
    </header>
  );
};
